/**
 *  Purpose: the modifications that are carried on the Payee Order objects for each command
 */

 import {initialState} from './index'
 import * as types from '../actions'
 import {logError} from "../utils/errorHandlingUtils"

 // STATE
 // payeeOrders:{
 //  payeeOrdersById:{},
 //  lastUpdatedAt: 0
 // }
 
const payeeOrdersReducer = (state = initialState.payeeOrders, action) => {
    const {type, payload} = action;
    let payeeOrdersById = {...state.payeeOrdersById}
    switch (type){
        case types.SAVE_PAYEE_ORDERS: {
           if(typeof payload.payeeOrders !== "object") {
               logError(`payeeOrdersReducer > SAVE_PAYEE_ORDERS: payeeOrders payload is not an object ${JSON.stringify(payload)}`)
               return state
           }
   
           payload.payeeOrders.forEach(payeeOrder => {
               payeeOrdersById[payeeOrder.id] = payeeOrder                                 
           })
           return {
               ...state,
               payeeOrdersById,
               lastUpdatedAt: Date.now()
           }
       }

        case types.UPDATE_PAYEE_ORDER: {
            if(typeof payload.payeeOrderId !== "string") {
                logError(`payeeOrdersReducer > UPDATE_PAYEE_ORDER: payeeOrderId in payload is not a string ${JSON.stringify(payload)}`)
                return state
            }
            if(typeof payload.update !== "object") {
                logError(`payeeOrdersReducer > UPDATE_PAYEE_ORDER: update in payload is not an object ${JSON.stringify(payload)}`)
                return state
            }
            const {payeeOrderId, update} = payload
            
            return {
                ...state,
                payeeOrdersById: {
                    ...payeeOrdersById,
                    [payeeOrderId]: {
                        ...payeeOrdersById[payeeOrderId],
                        ...update
                    }
                },
            }
        }

       case types.LOGOUT: {
           return initialState.payeeOrders
       }

        default: return state
    }
}

export default payeeOrdersReducer